import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=53ea221c"
import script from "./Query.vue?vue&type=script&lang=js"
export * from "./Query.vue?vue&type=script&lang=js"
import style0 from "./Query.vue?vue&type=style&index=0&id=53ea221c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports